import {Uuid} from '@common/types/index.types';

class RegionConstants {
  static readonly EUROPE = {uuid: '30913a2a-c7c9-4b5b-a218-c4f7a5c0aaf1', name: 'Europe'};
  static readonly NORTH_AMERICA = {uuid: '1260271c-f37e-4404-b2c1-b0d1fc5be29e', name: 'North America'};
  static readonly ASIA_PACIFIC = {uuid: '25bf1e63-2f08-45b3-ba29-5f15b19a9ab4', name: 'Asia-Pacific'};
  static readonly EMERGING_AND_SEEDS = {uuid: '031419c8-5bd8-4833-a3cc-ba2b4f36135e', name: 'Emerging and Seeds'};

  static getRegionNameByUuid(uuid: string): string | undefined {
    const regions = [this.EUROPE, this.NORTH_AMERICA, this.ASIA_PACIFIC, this.EMERGING_AND_SEEDS];
    const region = regions.find(region => region.uuid === uuid);
    return region?.name;
  }
}

export const mappingUuidRegion = [RegionConstants.EUROPE, RegionConstants.NORTH_AMERICA, RegionConstants.ASIA_PACIFIC, RegionConstants.EMERGING_AND_SEEDS].reduce(
  (acc: Record<Uuid, string>, {name, uuid}) => {
    acc[uuid] = name;
    return acc;
  },
  {}
);

export default RegionConstants;
